import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

import Home from '../views/Home.vue';
import Sponsors from '../views/Sponsors.vue';
import Players from '../views/Players.vue';
import Staff from '../views/Staff.vue';
import Ranking from '../views/Ranking.vue';
import Gallery from '../views/Gallery.vue';
import Album from '../views/Album.vue';
import NotFound from '../views/NotFound.vue';

const routes: RouteRecordRaw[] = [
  {
    name: 'home',
    path: '/',
    component: Home,
  },
  {
    name: 'sponsors',
    path: '/sponsor',
    component: Sponsors,
  },
  {
    name: 'players',
    path: '/squadra',
    component: Players,
  },
  {
    name: 'staff',
    path: '/organico',
    component: Staff,
  },
  {
    name: 'ranking',
    path: '/classifica',
    component: Ranking,
  },
  {
    name: 'gallery',
    path: '/gallery',
    component: Gallery,
  },
  {
    name: 'album',
    path: '/album/:id',
    component: Album,
  },
  {
    name: 'not-found',
    path: '/404',
    component: NotFound,
  },
  {
    name: '404',
    path: '/:pathMatch(.*)*',
    redirect: { name: 'not-found' },
  },
];

export const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior() {
    return { left: 0, top: 0 };
  },
});
